import { Component, OnInit } from '@angular/core';

import { getContactSelectors } from 'src/app/modules/collect-data/components/end-of-collection/store/contact.selectors';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IContactState } from 'src/app/modules/collect-data/components/end-of-collection/store/contact.state';
import { IRecomendations } from 'src/app/modules/interfaces/recomendations.interface';
import { RecomendationsService } from 'src/app/services/recomendations.service';
import { getCookie } from 'src/app/utils/get-cookie';
import { setContactAction } from 'src/app/modules/collect-data/components/end-of-collection/store/contact.actions';

@Component({
  selector: 'app-recomendation-pdf',
  templateUrl: './recomendation-pdf.component.html',
  styleUrls: ['./recomendation-pdf.component.scss'],
})
export class RecomendationPdfComponent implements OnInit {
  formsId: number;

  dataStoreRecomendation$: Observable<any>;
  dataStoreRecomendation: IContactState = {
    check: false,
    listContacts: [],
  };

   recomendationsData: IRecomendations[] = []

  constructor(private store: Store, private recomendationsService: RecomendationsService) {
      this.formsId = Number(getCookie('formsId'));
    }

  ngOnInit(): void {
    this.getStateRecomendation()
    this.loadingRecomendations()
  }

  getStateRecomendation() {
    this.dataStoreRecomendation$ = this.store.select(getContactSelectors);
    this.dataStoreRecomendation$.subscribe((value) => {
      this.dataStoreRecomendation = {
        ...(this.dataStoreRecomendation = value),
      };
    });
    
  }

  loadingRecomendations(){
    this.recomendationsService.getRecomendationsData(this.formsId).subscribe((response)=>{
        this.recomendationsData = response.data
      this.saveState()
    })
  }

  saveState(){
    this.dataStoreRecomendation = {
      ...this.dataStoreRecomendation,
      check: this.recomendationsData.length > 0,
      listContacts: this.recomendationsData.map(contact => ({
        name: contact.name,
        email: contact.email,
        phone: contact.phone,
        notes: contact.notes,
      })),
    };
    // this.setState(this.dataStoreRecomendation);
  }

  setState(data: IContactState): void {
      this.store.dispatch(setContactAction(data));
    }
  
}
